<div class="container-fluid">
<section>
	<header>
		<h1>{{ 'bmsjHipsterApp.sample.manager.title' | translate}} <jhi-help-link [helpLink]="helpLink"></jhi-help-link></h1>
	</header>
	<h2><img class="image-padding-with-text image-icon-md" src="content/images/review-list-details.png">{{ 'bmsjHipsterApp.sample.manager.list.details' | translate}}</h2>
	<div class="form-control-label"><a href (click)="browseList($event)" data-test="browseSampleListButton" jhiTranslate="bmsjHipsterApp.sample.manager.browse">Browse</a> {{ 'or' | translate}} <a href (click)="openSearch($event)">{{ 'search' | translate}} </a>{{ 'bmsjHipsterApp.sample.manager.search.samples.suffix' | translate}}</div>
	<div class="row">
        <section class="col">
            <div *ngIf="lists && lists.length" style="padding-top: 10px;">
                <nav>
                    <!-- Nav tabs -->
                    <ul class="nav nav-tabs" role="tablist">
                        <li class="nav-item pe-1" *ngFor="let list of lists" role="presentation">
                            <a class="nav-link" [class.active]="list.active" href="#list-{{list.id}}" aria-controls="home" (click)="setActive(list.id)" role="tab" data-bs-toggle="tab"
                               data-test="sampleListTab">
                                <truncate-span [showCopyButton]="false" [textInput]="list.listName" [maxLength]="20" [minWidth]="'30px'"></truncate-span>
                                <i class="fa fa-times close-nav-tab" (click)="closeTab(list)"></i>
                            </a>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <!-- Tab panes -->
                        <div *ngFor="let list of lists; trackBy: trackId" role="tabpanel" class="tab-pane container-fluid row" [class.active]="list.active" id="list-{{list.id}}">
                            <div class="col-xs-12 col-md-12">
                                <jhi-sample [sampleList]="list"></jhi-sample>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </section>
<!--        <section [hidden]="!listBuilderContext.visible" class="col-5 mb-3">-->
<!--            <jhi-list-builder></jhi-list-builder>-->
<!--        </section>-->
    </div>
</section>
</div>
